import { provideChameleonDesignSystem } from '../../provideChameleonDesignSystem';
import { chameleonDataTableCellV2 } from './DataTableCellV2.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDataTableCellV2({ prefix }));
}
